import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { burgerMenuReducerPath } from './const';
import { IBurgerMenuState } from './types';

export * from './const';
export * from './selectors';
export * from './types';

const initialState: IBurgerMenuState = {
  isVisible: false,
};

export const burgerMenuSlice = createSlice({
  name: `@@app/${burgerMenuReducerPath}`,
  initialState,
  reducers: {
    setVisible(state, action: PayloadAction<IBurgerMenuState['isVisible']>) {
      state.isVisible = action.payload;
    },
  },
});
